__turbopack_context__.v({
  "bold": "_8TkbgW_bold",
  "large": "_8TkbgW_large",
  "medium": "_8TkbgW_medium",
  "small": "_8TkbgW_small",
  "typography": "_8TkbgW_typography",
});
